import { StyledCalendarDay } from './Calendar.style';
import useCalendarStyles from './useCalendarStyles';

const useCalendarConfig = ({ forecast }) => {
  const calendarStyles = useCalendarStyles({ forecast });

  const renderDayContents = day => {
    const dayStyle = calendarStyles.getDayStyles(day);

    if (dayStyle) {
      return (
        <StyledCalendarDay
          className={dayStyle.classNames}
          backgroundColor={dayStyle.backgroundColor}
          borderColor={dayStyle.borderColor}
        >
          <span>{day.format('D')}</span>
        </StyledCalendarDay>
      );
    }
    return day.format('D');
  };

  const isOutsideRange = () => false;

  return { renderDayContents, isOutsideRange };
};

export default useCalendarConfig;
